<template>
  <ManagerPage pageType="standard" :id="id" :slug="slug" />
</template>

<script>
import ManagerPage from "./../products/src/productPage/Manager.vue";

export default {
  components: { ManagerPage },
  props: ["id", "slug"]
};
</script>



// WEBPACK FOOTER //
// src/components/template/ProductPage.vue